// extracted by mini-css-extract-plugin
export var actionButton = "_iv-t";
export var buttonContainer = "_iv-0";
export var buttonContainer2 = "_iv-1";
export var buttonSection = "_iv-2";
export var details = "_iv-3";
export var dropdownItem = "_iv-5";
export var dropdownItemsContainer = "_iv-4";
export var fileInput = "_iv-r";
export var headerButton = "_iv-6";
export var icon = "_iv-7";
export var input = "_iv-8";
export var macroListItem = "_iv-9";
export var mainContent = "_iv-a";
export var microText = "_iv-b";
export var modal = "_iv-w";
export var optionsButton = "_iv-c";
export var paperclip = "_iv-s";
export var pillContent = "_iv-d";
export var preview = "_iv-e";
export var preview2 = "_iv-f";
export var quillEditor = "_iv-q";
export var selectedMacro = "_iv-g";
export var sidebar = "_iv-h";
export var sidebarHeader = "_iv-j";
export var sidebarList = "_iv-i";
export var sidebarListItem = "_iv-k";
export var sidebarSearch = "_iv-l";
export var snoozeDurationWrapper = "_iv-v";
export var statusPillContainer = "_iv-m";
export var tagsContainer = "_iv-n";
export var unselectedMacro = "_iv-o";
export var variable = "_iv-u";
export var wrapper = "_iv-p";